/**
 * The status of an Order and wait row, order or PO, in words (BLU-1506):
 * Not sent yet / On the way, due 28 Oct / Late, was due 23 Oct / Out at
 * {supplier} / Short, on next order / Arrived, and for an order placed with the
 * supplier Placing order / Checking with {supplier} / Not placed. Drawn with the shared
 * `StatusPill` (ring geometry, the words inside, colour never alone); the
 * words and the tone come from `orderAndWaitStatusLabel` and
 * `orderAndWaitStatusTone` (lib/order-and-wait).
 */
import { useTranslation } from 'react-i18next';
import { StatusPill } from '@/components/shared/StatusPill';
import { useDateFnsLocale } from '@/lib/format-dates';
import { orderAndWaitStatusLabel, orderAndWaitStatusTone, waitingListStatusLabel } from '../lib/order-and-wait';

interface OrderAndWaitStatusChipProps {
  status: string | null | undefined;
  supplierName?: string | null;
  dueDate?: string | null;
  className?: string;
  /** `status` only for a chip whose words change while the page is open. */
  role?: 'status';
  /** The Waiting on blank list's words: Due 28 Oct or Not here yet for On the way. */
  waitingList?: boolean;
}

export function OrderAndWaitStatusChip({ status, supplierName, dueDate, className, role, waitingList }: OrderAndWaitStatusChipProps) {
  const { t } = useTranslation('orders');
  const locale = useDateFnsLocale();
  const label = waitingList ? waitingListStatusLabel : orderAndWaitStatusLabel;
  return (
    <StatusPill tone={orderAndWaitStatusTone(status)} className={className} role={role}>
      {label(t, status, { supplierName, dueDate, locale })}
    </StatusPill>
  );
}
